export default "__VITE_ASSET__CRCKBvEu__"